import { useState, useEffect, useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, AutoComplete, Divider, Select } from 'antd';
//import HeaderLogo from 'assets/img/logo/logo_header.png';
import HeaderLogo from 'assets/img/logo/LogoIstatHeader.svg';
import { useNavigate as useHistory } from 'react-router-dom';
import Search from 'services/search';
import _ from 'lodash';
import moment from 'moment';
import LangSelector from 'components/langSelector/LangSelector';
import { SearchOutlined } from '@ant-design/icons';
import IsMobile from 'components/IsMobile/IsMobile';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  initialState as Is_newReportCompiler,
  updateFilters,
  updateData,
  updateTextFilters,
  updateTableData
} from '../redux/reducers/NewReportCompiler.reducer';

function HeaderSubtitle({ envType, isMobile }) {
  switch (envType) {
    case 'local':
      return (
        <div className="situas-env-tag position-absolute p-1 pl-2 pr-2">
          LOCALE
        </div>
      );
    case 'dev':
      return (
        <div className="situas-env-tag position-absolute p-1 pl-2 pr-2">
          SVILUPPO
        </div>
      );
    case 'test':
      return (
        <div className="situas-env-tag position-absolute p-1 pl-2 pr-2">
          COLLAUDO
        </div>
      );

    default:
      return "";
  }
}

function Header() {
  const dispatch = useDispatch();
  const isMobile = IsMobile();

  const { t } = useTranslation();
  const [searchString, setSearchString] = useState();
  const [options, setOptions] = useState([]);
  const [selectedReport, setSelectedReport] = useState();
  const [value, setValue] = useState();
  const history = useHistory();

  const setSearchStringDebounced = useCallback(
    _.debounce((value) => setSearchString(value), 500, true),
    []
  );

  useEffect(() => {
    const SearchRep = async () => {
      const { data } = await Search.searchByWord(searchString);
      const opts = data?.items?.map((obj, i) => {
        return {
          value: obj['id_funzione'],
          label: obj['nome report'],
          report: obj
        };
      });
      setOptions(opts);
    };
    if (searchString?.length > 2) {
      SearchRep();
    }
  }, [searchString]);

  /* useEffect(() => {
    
  }, [selectedReport]); */
  const searchReport = () => {
    if (selectedReport !== undefined && selectedReport !== null) {
      const type = selectedReport['tipo analisi dati'];
      const tmpDataDa = moment(selectedReport.data_ini_val, 'DD/MM/YYYY');
      const tmpDataA = moment(selectedReport.data_fin_val, 'DD/MM/YYYY');
      dispatch(updateTableData(Is_newReportCompiler.tableData));
      dispatch(updateTextFilters(Is_newReportCompiler.textFilters));
      dispatch(updateFilters(Is_newReportCompiler.filters));
      switch (type) {
        case 'DATA':
          dispatch(updateData({ dataDaUp: tmpDataDa.format('YYYY-MM-DD'), dataAUp: null }));
          history(`/territorio/body?id=${selectedReport.id_funzione}&dateFrom=${tmpDataDa.format(`YYYY-MM-DD`)}`, {
            state: {
              dataDa: tmpDataDa.format(`DD-MM-YYYY`),
              dataA: null,
              periodoDate: [tmpDataDa.format('DD/MM/YYYY'), tmpDataA.format('DD/MM/YYYY')],
              funzione: selectedReport.id_funzione,
              title: 'Ricerca: ' + selectedReport['nome report'],
              mainTitle: selectedReport['nome report'],
              descrizione: selectedReport['descrizione report'],
              fromHome: false
            }
          });
          break;
        case 'PERIODO':
          dispatch(
            updateData({
              dataDaUp: tmpDataDa.format('YYYY-MM-DD'),
              dataAUp: tmpDataA.format('YYYY-MM-DD')
            })
          );
          history(`/variazioni/body?id=${selectedReport.id_funzione}&dateFrom=${tmpDataDa.format('YYYY-MM-DD')}&dateTo=${tmpDataA.format('YYYY-MM-DD')}`, {
            state: {
              dataDa: tmpDataDa.format(`DD-MM-YYYY`),
              dataA: tmpDataA.format(`DD-MM-YYYY`),
              periodoDate: [tmpDataDa.format('DD/MM/YYYY'), tmpDataA.format('DD/MM/YYYY')],
              funzione: selectedReport.id_funzione,
              title: 'Ricerca: ' + selectedReport['nome report'],
              mainTitle: selectedReport['nome report'],
              descrizione: selectedReport['descrizione report'],
              fromHome: false
            }
          });
          break;
        case 'ATTUALIZZAZIONE':
          dispatch(
            updateData({
              dataDaUp: tmpDataDa.format('YYYY-MM-DD'),
              dataAUp: tmpDataA.format('YYYY-MM-DD')
            })
          );
          history(`/ricostruzione-codici/body?id=${selectedReport.id_funzione}&dateFrom=${tmpDataDa.format('YYYY-MM-DD')}&dateTo=${tmpDataA.format('YYYY-MM-DD')}`, {
            state: {
              dataDa: tmpDataDa.format(`DD-MM-YYYY`),
              dataA: tmpDataA.format(`DD-MM-YYYY`),
              periodoDate: [tmpDataDa.format('DD/MM/YYYY'), tmpDataA.format('DD/MM/YYYY')],
              funzione: selectedReport.id_funzione,
              title: 'Ricerca: ' + selectedReport['nome report'],
              mainTitle: selectedReport['nome report'],
              descrizione: selectedReport['descrizione report'],
              fromHome: false
            }
          });
          break;
      }
    }
  };

  return (
    <div>
      <HeaderSubtitle envType={process.env.REACT_APP_ENV} />
      <div className={`logo w-100 d-flex justify-content-center align-items-center`}>
        <img src={HeaderLogo} aria-label="Istat Logo" />
      </div>
      <div 
        className={`d-flex header-title align-items-center ${
          isMobile ? 'flex-column' : ''
        }`}
        role="banner">
        <div>
          <h1
            style={{ minHeight: '60px', color: '#ffffff' }}
            className={`d-flex align-items-center header-main-title mb-0 ${
              isMobile ? 'justify-content-center text-center' : ''
            }
            `}>
            <Link id="logo" to="/">
              SITUAS
            </Link>
          </h1>
        </div>
        <div className={`pl-3 pr-3 ${
            isMobile ? 'd-none' : ''
          }`}>
          <div
            style={{ minHeight: !isMobile ? '100px' : '60px' }}
            className="d-flex align-items-center justify-content-center">
            <Divider className="header-divider" type="vertical" />
          </div>
        </div>
        <div>
          <div
              style={{ minHeight: !isMobile ? '100px' : '50px', lineHeight:'initial' }}
            className={`subtitle d-flex align-items-center header-subtitle ${
              isMobile ? 'justify-content-center text-center' : ''
            }`}>
            {t('header.title')}
          </div>
        </div>
        {/* FASE 3 - RICERCA OSCURATA
        <Col xs={24} sm={24} lg={9}>
          <div
            className={`d-flex align-items-center justify-content-${
              isMobile ? 'center w-100 ' : 'start pl-4'
            }`}>
            <Row className="ricerca-report">
              <Col span={18} role="search">
                <div>
                  <label id="searchLabel" htmlFor="inputRicerca" className="RicercaTxt">
                    Ricerca nel sito
                  </label>
                </div>
                <AutoComplete
                  id="inputRicerca"
                  className="input-ricerca w-100 h-100"
                  allowClear
                  options={options}
                  value={value}
                  onChange={(str) => {
                    setValue(str);
                  }}
                  onSelect={(val, obj) => {
                    setSelectedReport(obj.report);
                    setValue(obj.label);
                  }}
                  onSearch={(str) => {
                    setSearchStringDebounced(str || '');
                  }}
                  onClear={() => {
                    setValue();
                  }}
                  placeholder="Inserisci un termine"

                  aria-label="Ricerca un Termine"
                  aria-labelledby="searchLabel"
                  tabIndex="0"
                />
              </Col>
              <Col span={6} className="btnSearch">
                <button
                  className="w-100 btnSearchBtn"
                  onClick={() => {
                    searchReport();
                  }}
                  tabIndex="0">
                  cerca
                </button>
              </Col>
            </Row>
          </div> 
        </Col>
        */}
        {/* FASE 3 - RICERCA OSCURATA
        <Col xs={4} sm={1} lg={2}>
          <div
            className={`d-flex align-items-center justify-content-${
              isMobile ? 'center w-100 ' : 'start pl-4'
            }`}
            style={{ minHeight: !isMobile ? '100px' : '60px' }}>
            <LangSelector className={`langSelectorHeight`} />
          </div>
        </Col> 
        */}
      </div>
    </div>
  );
}

export default Header;
